// extracted by mini-css-extract-plugin
export default {"textContainer":"TextItem-module__textContainer___16Z1d","eventText":"TextItem-module__eventText___2-uWC","dateText":"TextItem-module__dateText___2-t4Q"};